import React from "react";

import { AlertDialogBackground, DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsTexts from "../../../constants/ConstantsTexts";

import "./WidgetAlertDialogOpenChangeRequestBlocked.css";

const WidgetAlertDialogOpenChangeRequestBlocked = ({ terminalName, onClose }) => {
  const message = ConstantsTexts.CODE_283.replace("{terminalName}", terminalName || "");

  return (
    <AlertDialogBackground onClick={onClose}>
      <DivColumn className="alert-dialog-open-change-request-blocked" onClick={(event) => event.stopPropagation()}>
        <ParagraphText className="alert-dialog-open-change-request-blocked-message">{message}</ParagraphText>
        <DivColumn className="alert-dialog-open-change-request-blocked-button" onClick={onClose}>
          <ParagraphText className="alert-dialog-open-change-request-blocked-button-text">{ConstantsTexts.CODE_284}</ParagraphText>
        </DivColumn>
      </DivColumn>
    </AlertDialogBackground>
  );
};

export default WidgetAlertDialogOpenChangeRequestBlocked;
